import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoadingStateService } from '@net3-multiplatform-client/libs';
import { UserService } from '../../users/services/user.service';

export const userDataGuard: CanActivateFn = async () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const loadingService = inject(LoadingStateService)

  try {
    loadingService.showLoadingPage.set(true);
    const user = await userService.loadUserInfo();
    const lista = user.memberships ?? [];
    // si nomes te una comunitat redireccionem a aquella
    if (lista.length === 1) {
      const community = lista[0];
      return router.createUrlTree(['/communities', community.schema_id]);
    }

    return true;
  } catch {
    return router.createUrlTree(['/signin']); // TODO: crear pantalla d'error
  }
};